import { usePartner } from '@/context/PartnerContext'
import apiClient from 'BrokerTsLib/src/Utils/apiClient'
import { useMutation, useQueryClient } from 'react-query'

export const useSignIn = () => {
  const { getBaseUrl } = usePartner()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: { token: string }) => apiClient.post<number>(`${getBaseUrl()}/SignIn?token=${data.token}`).then(res => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries(['isLogged'])
    }
  })
}